import { ReactComponent as amex } from '../assets/images/stripe-icons/amex.svg'
import { ReactComponent as diners } from '../assets/images/stripe-icons/diners.svg'
import { ReactComponent as discover } from '../assets/images/stripe-icons/discover.svg'
import { ReactComponent as jcb } from '../assets/images/stripe-icons/jcb.svg'
import { ReactComponent as mastercard } from '../assets/images/stripe-icons/mastercard.svg'
import { ReactComponent as unionpay } from '../assets/images/stripe-icons/unionpay.svg'
import { ReactComponent as unknown } from '../assets/images/stripe-icons/unknown.svg'
import { ReactComponent as visa } from '../assets/images/stripe-icons/visa.svg'

const CREDIT_CARDS = {
  amex,
  diners,
  discover,
  jcb,
  mastercard,
  unionpay,
  unknown,
  visa
}

export {
  CREDIT_CARDS
}
